import React, { FC, useState } from 'react'
import Tabs from '@bt-react/components/Tabs'
import { useSelector } from 'react-redux'
import { State } from '../../../dataStore/reducers/reducerType'

const UIDocumentDisplay: FC = () => {
  const keyValuePairs = (obj) => Object.entries(obj)
  const [selectedTab, setSelectedTab] = useState(1)
  const storeStateToDisplay = useSelector((state: State) => {
    if (selectedTab === 1) return state.layouts
    if (selectedTab === 2) return state.config
    if (selectedTab === 3) return state.user.data
    if (selectedTab === 4) return state.webcast
    if (selectedTab === 5) return state.syncUi
    if (selectedTab === 6) return state.questions
  })

  const handleSelectedTabClick = (tabIndex: number) => {
    setSelectedTab(tabIndex)
  }

  const tabsData = [
    { tabItem: <div onClick={() => handleSelectedTabClick(1)}>Layouts</div>, isActive: selectedTab === 1 },
    { tabItem: <div onClick={() => handleSelectedTabClick(2)}>Config</div>, isActive: selectedTab === 2 },
    { tabItem: <div onClick={() => handleSelectedTabClick(3)}>User</div>, isActive: selectedTab === 3 },
    { tabItem: <div onClick={() => handleSelectedTabClick(4)}>Webcast</div>, isActive: selectedTab === 4 },
    { tabItem: <div onClick={() => handleSelectedTabClick(5)}>SyncUi</div>, isActive: selectedTab === 5 },
    { tabItem: <div onClick={() => handleSelectedTabClick(6)}>Questions</div>, isActive: selectedTab === 6 }
  ]

  const handleCircularReferences = data => {
    const seen = new WeakSet();
    return JSON.stringify(data, (key, value) => {
      if (typeof value === 'object' && value !== null) {
        if (seen.has(value)) {
          // Circular reference found, return a placeholder value
          return '[Circular Reference]'
        }
        // Add the object to the set to track circular references
        seen.add(value)
      }
      return value;
    }, 2) // 2 is for indentation
  }

  return <section>
    <h3>UI Store State Info</h3>
    <Tabs tabs={tabsData}  />
    <div>
      <ul>
        {
          keyValuePairs(storeStateToDisplay).map(innerArray => innerArray.map((data, innerIndex) => (
            <li key={innerIndex}>
              { typeof data === 'object' ? ( <div>{handleCircularReferences(data)}</div> ) : <div> <strong></strong> {data.toString()}</div> }
            </li>
          )))
        }
      </ul>
    </div>
  </section>
}

export default UIDocumentDisplay